import { render, staticRenderFns } from "./SingleLightbox.vue?vue&type=template&id=bc10fc78"
import script from "./SingleLightbox.vue?vue&type=script&lang=js"
export * from "./SingleLightbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports